import { render, staticRenderFns } from "./Reachat.vue?vue&type=template&id=34315ff0&scoped=true&"
import script from "./Reachat.vue?vue&type=script&lang=js&"
export * from "./Reachat.vue?vue&type=script&lang=js&"
import style0 from "./Reachat.vue?vue&type=style&index=0&id=34315ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34315ff0",
  null
  
)

export default component.exports